// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 3t7wZMgJPQyyMw4DqH4rwx
// Component: V1-AgOz39N
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  useTrigger,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useScreenVariants } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: iP27SHKc3OuR/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import * as defaultcss from "../plasmic__default_style.module.css"; // plasmic-import: global/defaultcss
import * as projectcss from "./plasmic_valentino.module.css"; // plasmic-import: 3t7wZMgJPQyyMw4DqH4rwx/projectcss
import * as sty from "./PlasmicLanding.module.css"; // plasmic-import: V1-AgOz39N/css
import logo3XpngESkE6BC9Z from "./images/logo3Xpng.png"; // plasmic-import: eSkE6bC9Z/picture
import photoBooth11GifY9RLm2PCz from "./images/photoBooth11Gif.jpeg"; // plasmic-import: Y9rLm2PCz/picture
import qrCodepng3OKmaHYNm from "./images/qrCodepng3.png"; // plasmic-import: oKMA-hYNm/picture
import backstageBackgroundjpgNlK3RRUxA from "./images/backstageBackgroundjpg.jpeg"; // plasmic-import: NlK3rRUxA/picture
import iconClutchpngQGdQ5Hfi5 from "./images/iconClutchpng.png"; // plasmic-import: QGdQ5Hfi5/picture
import artistrypng5H5N2Tzir3 from "./images/artistrypng5.png"; // plasmic-import: h5n2tzir3/picture
import artistryHoverpng2UXFiEXv68 from "./images/artistryHoverpng2.png"; // plasmic-import: uXFiEXv68/picture
import artistryFocuspng2SuOfbmTLz from "./images/artistryFocuspng2.png"; // plasmic-import: suOfbmTLz/picture
import iconLipDreamspngTP1XKljlq from "./images/iconLipDreamspng.png"; // plasmic-import: tP1xKLJLQ/picture
import enterpng2Yk1G8G57S from "./images/enterpng2.png"; // plasmic-import: YK1g8G57S/picture
import enterHoverpngGqnYvxoFl from "./images/enterHoverpng.png"; // plasmic-import: GqnYVXOFl/picture
import enterFocuspngBpfiJceLp from "./images/enterFocuspng.png"; // plasmic-import: BPFIJceLP/picture

export const PlasmicLanding__VariantProps = new Array();

export const PlasmicLanding__ArgProps = new Array();

function PlasmicLanding__RenderFunc(props) {
  const { variants, args, overrides, forNode, dataFetches } = props;
  const [isN5121186Hover, triggerN5121186HoverProps] = useTrigger(
    "useHover",
    {}
  );

  const [isN5121186Active, triggerN5121186ActiveProps] = useTrigger(
    "usePressed",
    {}
  );

  const [isN5121251Hover, triggerN5121251HoverProps] = useTrigger(
    "useHover",
    {}
  );

  const [isN5121251Active, triggerN5121251ActiveProps] = useTrigger(
    "usePressed",
    {}
  );

  const triggers = {
    hover_5121186: isN5121186Hover,
    active_5121186: isN5121186Active,
    hover_5121251: isN5121251Hover,
    active_5121251: isN5121251Active
  };

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants()
  });

  return (
    <React.Fragment>
      <div className={defaultcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            defaultcss.all,
            projectcss.root_reset,
            sty.root
          )}
        >
          <div className={classNames(defaultcss.all, sty.box__cqMls)}>
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__t7Tze)}
              role={"img"}
              src={logo3XpngESkE6BC9Z}
            />
          </div>

          <div className={classNames(defaultcss.all, sty.box__bBxHd)}>
            <div
              data-plasmic-name={"videoBox"}
              data-plasmic-override={overrides.videoBox}
              className={classNames(defaultcss.all, sty.videoBox)}
            />

            <div
              data-plasmic-name={"chatBox"}
              data-plasmic-override={overrides.chatBox}
              className={classNames(defaultcss.all, sty.chatBox)}
            >
              <div
                data-plasmic-name={"chatroll"}
                data-plasmic-override={overrides.chatroll}
                className={classNames(defaultcss.all, sty.chatroll)}
              />

              <div
                data-plasmic-name={"disclaimer"}
                data-plasmic-override={overrides.disclaimer}
                className={classNames(
                  defaultcss.all,
                  defaultcss.__wab_text,
                  sty.disclaimer
                )}
              >
                {
                  'US Only.  By using Chat you agree your information will be collected and used subject to our <a href=" https://www.valentino-beauty.us/privacy-policy.html">privacy policy</a> and <a href="https://www.valentino-beauty.us/customer-service-terms-and-conditions.html">terms of use</a>.  Please do not share personal information such as credit card numbers or health concerns with our Bot.'
                }
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"photoboothBox"}
            data-plasmic-override={overrides.photoboothBox}
            className={classNames(defaultcss.all, sty.photoboothBox)}
          >
            <img
              data-plasmic-name={"photoboothGif"}
              data-plasmic-override={overrides.photoboothGif}
              alt={""}
              className={classNames(defaultcss.img, sty.photoboothGif)}
              role={"img"}
              src={photoBooth11GifY9RLm2PCz}
            />

            <img
              data-plasmic-name={"photoboothLogo"}
              data-plasmic-override={overrides.photoboothLogo}
              alt={""}
              className={classNames(defaultcss.img, sty.photoboothLogo)}
              role={"img"}
              src={qrCodepng3OKmaHYNm}
            />
          </div>

          <div
            data-plasmic-name={"carousel"}
            data-plasmic-override={overrides.carousel}
            className={classNames(defaultcss.all, sty.carousel)}
          />

          <div
            data-plasmic-name={"breakouts"}
            data-plasmic-override={overrides.breakouts}
            className={classNames(defaultcss.all, sty.breakouts)}
          >
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img___9WRzr)}
              role={"img"}
              src={backstageBackgroundjpgNlK3RRUxA}
            />

            <div
              data-plasmic-name={"body"}
              data-plasmic-override={overrides.body}
              className={classNames(defaultcss.all, sty.body)}
            >
              <div
                className={classNames(
                  defaultcss.all,
                  defaultcss.__wab_text,
                  sty.box__oRiod
                )}
              >
                {"backSTAGE CONVERSATION "}
              </div>

              <div
                className={classNames(
                  defaultcss.all,
                  defaultcss.__wab_text,
                  sty.box__qrCx1
                )}
              >
                {
                  "Join our Valentino Beauty team to discuss further and share your beauty dreams."
                }
              </div>

              <div
                data-plasmic-name={"buttons"}
                data-plasmic-override={overrides.buttons}
                className={classNames(defaultcss.all, sty.buttons)}
              >
                {false ? (
                  <div
                    data-plasmic-name={"firstBreakout"}
                    data-plasmic-override={overrides.firstBreakout}
                    className={classNames(defaultcss.all, sty.firstBreakout)}
                  >
                    <img
                      alt={""}
                      className={classNames(defaultcss.img, sty.img__tr4G2)}
                      role={"img"}
                      src={iconClutchpngQGdQ5Hfi5}
                    />

                    {false ? (
                      <div
                        data-plasmic-name={"clutchText"}
                        data-plasmic-override={overrides.clutchText}
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.clutchText
                        )}
                      >
                        {"Lorem Ipsum"}
                      </div>
                    ) : null}

                    <img
                      alt={""}
                      className={classNames(defaultcss.img, sty.img__kb5C9)}
                      role={"img"}
                      src={
                        triggers.active_5121186
                          ? artistryFocuspng2SuOfbmTLz
                          : triggers.hover_5121186
                          ? artistryHoverpng2UXFiEXv68
                          : artistrypng5H5N2Tzir3
                      }
                      data-plasmic-trigger-props={[
                        triggerN5121186HoverProps,
                        triggerN5121186ActiveProps
                      ]}
                    />
                  </div>
                ) : null}

                <div
                  data-plasmic-name={"secondBreakout"}
                  data-plasmic-override={overrides.secondBreakout}
                  className={classNames(defaultcss.all, sty.secondBreakout)}
                >
                  <img
                    alt={""}
                    className={classNames(defaultcss.img, sty.img__gOvO3)}
                    role={"img"}
                    src={iconLipDreamspngTP1XKljlq}
                  />

                  {false ? (
                    <div
                      data-plasmic-name={"clutchText2"}
                      data-plasmic-override={overrides.clutchText2}
                      className={classNames(
                        defaultcss.all,
                        defaultcss.__wab_text,
                        sty.clutchText2
                      )}
                    >
                      {"Lorem Ipsum"}
                    </div>
                  ) : null}

                  <img
                    alt={""}
                    className={classNames(defaultcss.img, sty.img___32Y0R)}
                    role={"img"}
                    src={
                      triggers.active_5121251
                        ? enterFocuspngBpfiJceLp
                        : triggers.hover_5121251
                        ? enterHoverpngGqnYvxoFl
                        : enterpng2Yk1G8G57S
                    }
                    data-plasmic-trigger-props={[
                      triggerN5121251HoverProps,
                      triggerN5121251ActiveProps
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "videoBox",
    "chatBox",
    "chatroll",
    "disclaimer",
    "photoboothBox",
    "photoboothGif",
    "photoboothLogo",
    "carousel",
    "breakouts",
    "body",
    "buttons",
    "firstBreakout",
    "clutchText",
    "secondBreakout",
    "clutchText2"
  ],

  videoBox: ["videoBox"],
  chatBox: ["chatBox", "chatroll", "disclaimer"],
  chatroll: ["chatroll"],
  disclaimer: ["disclaimer"],
  photoboothBox: ["photoboothBox", "photoboothGif", "photoboothLogo"],
  photoboothGif: ["photoboothGif"],
  photoboothLogo: ["photoboothLogo"],
  carousel: ["carousel"],
  breakouts: [
    "breakouts",
    "body",
    "buttons",
    "firstBreakout",
    "clutchText",
    "secondBreakout",
    "clutchText2"
  ],

  body: [
    "body",
    "buttons",
    "firstBreakout",
    "clutchText",
    "secondBreakout",
    "clutchText2"
  ],

  buttons: [
    "buttons",
    "firstBreakout",
    "clutchText",
    "secondBreakout",
    "clutchText2"
  ],

  firstBreakout: ["firstBreakout", "clutchText"],
  clutchText: ["clutchText"],
  secondBreakout: ["secondBreakout", "clutchText2"],
  clutchText2: ["clutchText2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicLanding__ArgProps,
      internalVariantPropNames: PlasmicLanding__VariantProps
    });

    const { dataFetches } = props;
    return PlasmicLanding__RenderFunc({
      variants,
      args,
      overrides,
      dataFetches,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLanding";
  } else {
    func.displayName = `PlasmicLanding.${nodeName}`;
  }
  return func;
}

export const PlasmicLanding = Object.assign(
  // Top-level PlasmicLanding renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    videoBox: makeNodeComponent("videoBox"),
    chatBox: makeNodeComponent("chatBox"),
    chatroll: makeNodeComponent("chatroll"),
    disclaimer: makeNodeComponent("disclaimer"),
    photoboothBox: makeNodeComponent("photoboothBox"),
    photoboothGif: makeNodeComponent("photoboothGif"),
    photoboothLogo: makeNodeComponent("photoboothLogo"),
    carousel: makeNodeComponent("carousel"),
    breakouts: makeNodeComponent("breakouts"),
    body: makeNodeComponent("body"),
    buttons: makeNodeComponent("buttons"),
    firstBreakout: makeNodeComponent("firstBreakout"),
    clutchText: makeNodeComponent("clutchText"),
    secondBreakout: makeNodeComponent("secondBreakout"),
    clutchText2: makeNodeComponent("clutchText2"),
    // Metadata about props expected for PlasmicLanding
    internalVariantProps: PlasmicLanding__VariantProps,
    internalArgProps: PlasmicLanding__ArgProps
  }
);

export default PlasmicLanding;
/* prettier-ignore-end */
